import styled from "styled-components";

export const ContainerNoti = styled.div`
  margin: 20px;
  .notification-trigger {
    width: 36px;
    height: 36px;
    border-radius: 90%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .number-circle {
    position: absolute;
    top: -5px;
    right: -2px;
    width: 20px;
    height: 20px;
    background-color: var(--color-primary);
    border-radius: 90%;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    padding: 4px;
    color: #fff !important ;
  }
  cursor: pointer;
`;

export const CircleMenu = styled.div``;
